<section fxLayout="column" class="h-100 overflow-hidden">
    <section class="py-4 px-5 overflow-hidden" fxLayout="row" fxLayoutAlign="space-between" fxFlex="1 1 auto">
        <section fxFlex="1 1 48%" fxLayout="column">
            <div class="mb-4" fxFlex="1 1 5%" fxLayout="row" fxLayoutAlign="space-between center">
                <h2>{{translate.getLng('INVERTER_CUSTOMIZE')}}</h2>
                <div fxLayout="row" fxLayoutAlign="flex-end center">
                    <button (click)="addInverter()" class="sen-secondary-icon bg-white" mat-fab>
                        <mat-icon class="mb-2">add</mat-icon>
                    </button>
                    <button (click)="triggerConfirmation()" class="sen-secondary-icon ml-3 bg-white"
                        [disabled]="!(selectedSubGen+1)" mat-fab>
                        <mat-icon class="mb-2">delete</mat-icon>
                    </button>
                </div>
            </div>
            <div *ngIf="selectedInverterCombo && allInvertersList" fxFlex="1 1 auto" class="overflow-auto">
                <mat-card (click)="showMPPT(i, s)" matBadge="{{getTotalPanels(s.mppt)}}"
                    *ngFor="let s of selectedInverterCombo; let i = index" fxLayout="row"
                    class="sen-cursor-pointer p-2 m-4"
                    [ngClass]="selectedSubGenMPPTInd == i ? 'sen-menu-blue-bg ' : 'sen-info-color-bg'"
                    fxLayoutAlign="space-between center">
                    <div fxLayout="row" fxLayoutAlign="center center">
                        <mat-checkbox [checked]="selectedSubGen == i" class="ml-3" (change)="selectSubGen(i, $event)">
                        </mat-checkbox>
                        <div class="ml-4">
                            <input class="border-bottom border-dark mb-2" [(ngModel)]="s.name" matInput>
                            <div class="sen-fs10">{{getInverterName(s)}}</div>
                        </div>
                    </div>
                </mat-card>
            </div>
        </section>
        <section fxFlex="1 1 48%">
            <p class="mb-0">
                <button class="sen-fs10 sen-no-pointer" mat-raised-button>
                    <span><b>{{translate.getLng('SELECTED_MODUL')}}:</b> {{SIService.selectedPanel.name | truncate:30}},
                        <b>{{translate.getLng('PDC')}}:</b>
                        {{SIService.selectedPanel.Pdc}}</span>
                </button>

            </p>
            <table class="border-0 w-75 mt-5">
                <tr>
                    <td class="p-2 text-white border-bottom border-white sen-active-main-menu">
                        {{translate.getLng('TOTAL_PANELS')}}:</td>
                    <td class="p-2 border border-dark border-left-0">{{selectedInverter.panelCount}} ({{convertToLocalNumber(totalKW)}}
                        {{translate.getLng('UNIT_KWP')}})
                    </td>
                </tr>
                <tr>
                    <td class="p-2 text-white sen-active-main-menu">{{translate.getLng('INTERCONNECTED_PANELS')}}:</td>
                    <td class="p-2 border-bottom border-right border-dark">{{interConnectedPanels}}
                        ({{convertToLocalNumber(interConnectedPanelsKW)}} {{translate.getLng('UNIT_KWP')}})</td>
                </tr>
            </table>
            <h5 class="my-3">{{selectedSubGenMPPT?.name}}</h5>
            <table *ngIf="dataSource.data.length" mat-table class="w-75 mt-4 table" [dataSource]="dataSource">
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let element;let i = index;">
                        <span class="d-inline-block pr-5">{{translate.getLng('MPPT')}}{{i+1}}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="count">
                    <th mat-header-cell *matHeaderCellDef>{{translate.getLng('STRING_COUNT')}}</th>
                    <td mat-cell *matCellDef="let element">
                        <mat-form-field class="w-50 text-right sen-number-input font-weight-bold sen-fs16">
                            <input type="number" min="0"  (input)="setInterConnectedPanelsCount()"
                                [(ngModel)]="element.stringCount" matInput>
                        </mat-form-field>
                    </td>
                </ng-container>
                <ng-container matColumnDef="panels">
                    <th mat-header-cell *matHeaderCellDef>{{translate.getLng('PANELS_PER_STRING')}}</th>
                    <td mat-cell *matCellDef="let element">
                        <mat-form-field class="w-50 text-right sen-number-input font-weight-bold sen-fs16">
                            <input type="number" min="0" (input)="setInterConnectedPanelsCount()"
                                [(ngModel)]="element.panelCountPerString" matInput>
                        </mat-form-field>
                    </td>
                </ng-container>
                <tr class="w-100" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr class="w-100" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

        </section>
    </section>
    <div class="p-2 my-2" fxLayout="row" fxLayoutAlign="flex-end center">
        <button class="px-5 py-2" mat-raised-button color="primary"
            [routerLink]="[prevPath]">{{translate.getLng('PREV')}}</button>
        <button class="ml-3 px-5 py-2" (click)="goToNext()" mat-raised-button
            color="primary">{{translate.getLng('NEXT')}}</button>
    </div>
</section>